import type { LocationQueryRaw, LocationQueryValue } from 'vue-router'

import type { BaseL5Keys } from '~/composables/useL5'

export interface PortfolioFilterQuery extends BaseL5Keys {
    year_from?: string
    year_to?: string
}

const defaultQuery: { [key: string]: string | number | string[] | number[] } = {
    limit: 15,
    region_id: 0,
}

export function changeDefaultQuery(values: [string, string | number][]) {
    values.forEach(([name, value]) => {
        defaultQuery[name] = value
    })
}

export async function setQuery(
    values: [string, string | number | string[] | number[]][]
) {
    const route = useRoute()
    const router = useRouter()

    const newFilters: LocationQueryRaw = { ...route.query }

    values.forEach(([name, value]) => {
        newFilters[name] = String(value) as LocationQueryValue

        if (
            defaultQuery[name] === value ||
            (Array.isArray(value) && value.length === 0)
        ) {
            newFilters[name] = undefined
        }
    })

    newFilters.page = undefined

    await nextTick()
    router.replace({
        query: newFilters,
    })
}
